import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import SettingsLayer from "../components/SettingsLayer";

const SettingsPage = () => {
  return (
    <>
      <Breadcrumb title="Settings" />
      <SettingsLayer />
    </>
  );
};

export default SettingsPage;